import {
  Configuration,
  DefaultApi,
  MasterApi,
  ProductionActionApi,
  ScmApi,
  SpcApi,
  UserApi,
} from "@sizlcorp/sizl-api-document/dist/models";
import axios from "axios";

export const BASE_URL = process.env.REACT_APP_BASE_URL ?? "https://daeil-mes3-api.sizl.co.kr";

export const axiosInstance: any = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("authToken"),
  },
  timeout: 1000 * 60 * 60 * 24 * 7,
});

axiosInstance.interceptors.request.use((config: any) => {
  if (!config.headers) return config;
  const accessToken = localStorage.getItem("authToken");

  if (accessToken && config.headers) {
    config.headers["Authorization"] = "Bearer " + accessToken;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (res: any) => {
    return res;
  },
  async (error: any) => {
    if (
      error.config &&
      error.response &&
      error.response.status === 200
      // error.response.status !== 401 &&
      // error.response.status !== 400
    ) {
      error.config._retry = true;
      const refreshToken = localStorage.getItem("authToken");
      error.config.headers.refreshToken = refreshToken;

      return axios.create({
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + refreshToken,
          "Content-Type": "application/json",
          withCredentials: true,
        },
      });
      // .then((res) => {
      //     if (res.status === 200 && res.data.refreshToken) {
      //         localStorage.setItem('authToken', res.data.accessToken)
      //         const accessToken = localStorage.getItem('authToken')
      //         error.config.headers["Authorization"] = accessToken
      //         return axiosInstance(error.config)
      //     }
      // })
    }

    return Promise.reject(error);
  }
);

const defaultAxios = (url: string) => {
  return new DefaultApi(
    {
      apiKey: localStorage.getItem("authToken"),
    } as Configuration,
    url,
    axiosInstance
  );
};

const masterAxios = (url: string) => {
  return new MasterApi(
    {
      apiKey: localStorage.getItem("authToken"),
    } as Configuration,
    url,
    axiosInstance
  );
};

const userAxios = (url: string) => {
  return new UserApi(
    {
      apiKey: localStorage.getItem("authToken"),
    } as Configuration,
    url,
    axiosInstance
  );
};

const productionAxios = (url: string) => {
  return new ProductionActionApi(
    {
      apiKey: localStorage.getItem("authToken"),
    } as Configuration,
    url,
    axiosInstance
  );
};

const spcAxios = (url: string) => {
  return new SpcApi(
    {
      apiKey: localStorage.getItem("authToken"),
    } as Configuration,
    url,
    axiosInstance
  );
};

const scmAxios = (url: string) => {
  return new ScmApi(
    {
      apiKey: localStorage.getItem("authToken"),
    } as Configuration,
    url,
    axiosInstance
  );
};

export const ProductionInstance = productionAxios(BASE_URL);
export const UserInstance = userAxios(BASE_URL);
export const DefaultInstance = defaultAxios(BASE_URL);
export const MasterInstance = masterAxios(BASE_URL);
export const SpcInstance = spcAxios(BASE_URL);
export const ScmInstance = scmAxios(BASE_URL);

export default DefaultInstance;
